// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1JOi5","box":"WorkspacesBox_box__152Y0","node":"WorkspacesBox_node__1QHbz"};